//imports
import { all } from 'redux-saga/effects';

//Views
import createEditDashboardSagas from 'Modules/dashboard/views/.components/dashboardPanel/.components/createEditDashboard/redux/saga';
import gadgetChartSagas from 'Modules/dashboard/views/.components/chart/.components/forms/createEditChart/redux/saga';
import dashboardPanelSagas from 'Modules/dashboard/views/.components/dashboardPanel/redux/saga';
import deleteDashboardSagas from 'Modules/dashboard/views/.components/dashboardPanel/.components/deleteDashboard/redux/saga';
import deleteChartSagas from 'Modules/dashboard/views/.components/chart/.components/deleteChart/redux/saga';
import vidFleetClipRequestsDetailsSagas from 'Modules/dashboard/views/.components/dashboardPanel/.components/vidFleetClipRequestsDetails/redux/saga';
import firmwareDetailsSagas from 'Modules/dashboard/views/.components/dashboardPanel/.components/firmwareDetails/redux/saga';
import devicesByStatusSagas from 'Modules/dashboard/views/.components/chart/.components/devicesByStatus/redux/saga';
import lastReadingDetailsSagas from 'Modules/dashboard/views/.components/dashboardPanel/.components/lastReadingDetails/redux/saga';
import maintenanceWarningsDetailsSagas from 'Modules/dashboard/views/.components/dashboardPanel/.components/maintenanceWarningsDetails/redux/saga';
import shareDashboardSagas from 'Modules/dashboard/views/.components/dashboardPanel/.components/shareDashboard/redux/saga';
//merge sagas
export default function* rootSaga() {
    yield all([
        createEditDashboardSagas(),
        gadgetChartSagas(),
        dashboardPanelSagas(),
        deleteDashboardSagas(),
        deleteChartSagas(),
        vidFleetClipRequestsDetailsSagas(),
        firmwareDetailsSagas(),
        devicesByStatusSagas(),
        lastReadingDetailsSagas(),
        maintenanceWarningsDetailsSagas(),
        shareDashboardSagas(),
    ]);
}